import type { IconProps } from './types';

export function Top({ size = 24, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="none"
      stroke="currentColor"
      strokeWidth="14"
      strokeLinejoin="round"
      strokeLinecap="round"
      {...props}
    >
      <path d="M56 104 Q56 92 68 92 L100 92 Q116 108 128 108 Q140 108 156 92 L188 92 Q200 92 200 104 L200 160 Q200 172 188 172 L68 172 Q56 172 56 160 Z" />
    </svg>
  );
}
